import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://bezukphojqhbyfwwcaeo.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJlenVrcGhvanFoYnlmd3djYWVvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQwMzMwOTYsImV4cCI6MjA5OTYwOTA5Nn0.lIcHVCw7BM7P5MIdRT4Keezq0AMBBJG53yB_YcrdbTg';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
